// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._195g1i6y{margin-inline:var(--ds-space-negative-025,-2px)}\n._1mouze3t{margin-block:var(--ds-space-0,0)}._16jlidpf{flex-grow:0}\n._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}\n._lcxvglyw{pointer-events:none}\n._syazjjyb{color:var(--ds-text-subtle,#42526e)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
